import React, { useEffect, useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch, useSelector } from 'react-redux';
import { setCompany } from '../store/reducers/projectSlice';
import {} from '../store/reducers/hubSlice';
import { HubConnectionState } from '@microsoft/signalr';
import axios from 'axios';
import { globalConfig } from '../configuration/config';

export default function SelectCompany(props) {
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.project.companyId);
  const userInfo = useSelector((state) => state.users.currentUser);
  const hub = useSelector((state) => state.hub.hubs);
  const [searchCompany, setSearchCompany] = useState('');
  const [filteredCompanies, setFilteredCompanies] = useState([])
  const isDefaultCompany =  props?.company?.find((company) => company?.isDefaultCompany == true);
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectSwitch, setSelectSwitch] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1); // Индекс выделенного элемента

  const switchSearch = () => {
    setSelectSwitch(!selectSwitch)
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [filteredCompanies]);

  const handleKeyDown = (e) => {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) => 
        prevIndex < filteredCompanies.length - 1 ? prevIndex + 1 : prevIndex
      );
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setHighlightedIndex((prevIndex) => 
        prevIndex > 0 ? prevIndex - 1 : prevIndex
      );
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (highlightedIndex >= 0) {
        handleChange(filteredCompanies[highlightedIndex]);
      }
    }    
  };

  useEffect(() => {
    if (props.companyId) {
      if (!selectedCompany) {
        setSelectedCompany(props.company.find((company) => company.id === props.companyId));
      }
      dispatch(setCompany(props.companyId));
      localStorage.setItem('company', JSON.stringify({ id: props.companyId }));
    } else {
      dispatch(setCompany(isDefaultCompany?.id));
    }
    setFilteredCompanies(props?.company);
    if (searchCompany.length > 0) {
      setFilteredCompanies(props?.company?.filter(company => company.name.toLowerCase().includes(searchCompany.toLowerCase())));
    }
  }, [props.company]);

  const handleInputChange = (event) => {
    const newValue = event.target.value;
    setSearchCompany(newValue);
    setFilteredCompanies(props?.company?.filter(company => company.name.toLowerCase().includes(newValue.toLowerCase())));
  };

  const handleChange = (company) => {    
    setSelectedCompany(company);    
    props.onChangeCompany(company.id);
    dispatch(setCompany(company.id));
    localStorage.setItem('company', JSON.stringify({ id: company.id }));
    localStorage.removeItem('group');
    setSelectSwitch(false)
  };

  const makeCompanyFavorite = async(company) => {
    try {
      await axios.get(
        `${globalConfig.config.common.api}Companies/AddUserInCompany?guidUser=${userInfo.guid}&idCompany=${company.id}&isFavorite=${!company.isFavorite}`,
        { withCredentials: true },
      ).then((response) => {
        props.onMakeFavoriteCompany();
      })
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    document.querySelector(".bm-menu-wrap").addEventListener('click', handlerMenuClick);

    return () => {
      document.querySelector(".bm-menu-wrap").removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const handlerMenuClick = (event) => {
    const classesToCheck = ["bm-item-list", "user-info-container", "bm-menu"];

    if (classesToCheck.includes(event.target.className)) {
      setSelectSwitch(false);
    }
  }

  return (
    <>
      {userInfo && (
        <div className="user-info-container">
          <img src={userInfo.profilePictureFilePath} className="user-picture"></img>
          <div className="user-name--top">
            {userInfo.name + ' ' + userInfo.lastName && userInfo.lastName}
          </div>
        </div>
      )}
      {hub?.state === HubConnectionState.Connected ? (
        <div>
          <div
            onClick={switchSearch} 
            class="select-wrapper"
          >
            <div class="select-arrow"/>
            {selectedCompany?.name || isDefaultCompany?.name} 
          </div>
          <div className={`select-dropdown ${selectSwitch ? 'show' : ''}`}>
            <input
              class="select-input"
              type="text"
              placeholder="Введите название"
              value={searchCompany}
              onChange={handleInputChange}
            />
            <div class="select-list">
              {filteredCompanies?.map((company, index) => {
                return <div 
                  onClick={() => handleChange(company)} 
                  class="select-option"
                  className={`select-option ${highlightedIndex === index ? 'highlighted' : ''}`}
                >
                  {company.name}
                  <div 
                    onClick={(e) => {
                      e.stopPropagation();
                      makeCompanyFavorite(company);
                    }}
                    className={`img-star ${company.isFavorite ? 'active' : ''}`}
                  />
                </div>;
              })}
              {filteredCompanies?.length == 0 && 
                <div class="no-results">
                  <span> Нет совпадений </span>
                </div>
              }
            </div>
          </div>
        </div>
      ) : (
        <FormControl className="select-company" variant="outlined" disabled>
          {companyId && (
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={companyId}
              onChange={handleChange}
              label="Age"
              sx={{ color: 'white' }}>
              {props?.company?.map((c) => {
                return <MenuItem value={c.id}>{c.name}</MenuItem>;
              })}
            </Select>
          )}
        </FormControl>
      )}
    </>
  );
}
